import { type FC } from 'react';
import { usePublicStorageLocations } from 'src/apis/storage/use-public-storage-locations';
import type { StorageServiceRootRequest } from 'src/apis/storage/use-storage-service-root';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { storageLocationsOfferCreateParams } from 'src/pages/storage/locations-new/utils';
import { StorageOfferCreateForm } from 'src/pages/storage/offers-new/create/offer-create-form';

type Props = {
  storageServiceRoot: Successful<StorageServiceRootRequest>;
};

export const StorageOfferCreate: FC<Props> = ({ storageServiceRoot }) => {
  const storageLocations = usePublicStorageLocations({
    storageServiceRoot,
    params: storageLocationsOfferCreateParams,
  });

  if (!storageLocations.response) {
    return <PageSpinner />;
  }

  return (
    <StorageOfferCreateForm
      storageServiceRoot={storageServiceRoot}
      storageLocations={storageLocations}
    />
  );
};
